import React, { useEffect } from "react";
import PropTypes from "prop-types";

// components
import SectionContainer from "core/SectionContainer";
import TextWithButton from "core/TextWithButton";
import FourUp from "core/FourUp";
import Heading from "core/Heading";

// styles
import colors from "core/colors";

// data
import { subText, button, boxHeading, boxes } from "./data";

const ConfirmationPage = ({ headingTitle }) => {
    useEffect(() => {
        // We need to manually take control of the browsers scrollRestoration
        window.history.scrollRestoration = "manual";

        if (window.pageYOffset !== 0) {
            window.scrollTo(0, 0);
        }
    }, []);

    return (
        <>
            <SectionContainer>
                <TextWithButton
                    text={headingTitle}
                    headingSize="3xl"
                    headingBottomSpacing="xl"
                    subtext={subText}
                    subtextAlignment="left"
                    buttons={button}
                    buttonAlignment="left"
                />
            </SectionContainer>

            <SectionContainer bgColor={colors.mist}>
                <Heading
                    size="xl"
                    alignment="left"
                    bottomSpacing="4xl"
                    type="h2"
                >
                    {boxHeading}
                </Heading>
                <FourUp boxes={boxes} />
            </SectionContainer>
        </>
    );
};

ConfirmationPage.propTypes = {
    headingTitle: PropTypes.string.isRequired
};

export default ConfirmationPage;
